import { defineComponent, ref, computed, onBeforeUnmount } from "vue";
import uniqueId from "./component-library253.mjs";
import { getConfig } from "./component-library2.mjs";
import { addFocusTrap } from "./component-library90.mjs";
import slugify from "./component-library84.mjs";
import Heading from "./component-library6.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "base-dialog",
  props: {
    customClass: { default: void 0 },
    customContainerClass: { default: void 0 },
    dataTealiumRel: { default: void 0 },
    headingText: { default: void 0 },
    ariaLabel: { default: void 0 },
    closeOnBackdrop: { type: Boolean },
    closeAutofocus: { type: Boolean },
    isModal: { type: Boolean },
    disableFocusTrap: { type: Boolean }
  },
  emits: ["onCloseModal"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const uid = ref(uniqueId());
    const dialogElement = ref(null);
    const isDialogOpen = ref(false);
    const timeout = ref(null);
    const { tealium } = getConfig();
    const tealiumName = computed(() => props.isModal ? "modal" : "flyout");
    function closeDialog() {
      var _a;
      (_a = dialogElement.value) == null ? void 0 : _a.close();
    }
    const handleKeyEvent = (event) => {
      if (!dialogElement.value)
        return;
      if (event.key === "Escape") {
        closeDialog();
      }
    };
    const getTealiumRel = () => {
      var _a;
      if (props.dataTealiumRel)
        return slugify(props.dataTealiumRel);
      const header = (_a = dialogElement.value) == null ? void 0 : _a.querySelector(".base-dialog__header");
      return slugify((header == null ? void 0 : header.innerText) || "");
    };
    const focusTrap = addFocusTrap(handleKeyEvent);
    function openDialog() {
      isDialogOpen.value = true;
      if (timeout.value) {
        clearTimeout(timeout.value);
      }
      timeout.value = setTimeout(() => {
        var _a, _b;
        if (props.isModal) {
          (_a = dialogElement.value) == null ? void 0 : _a.showModal();
        } else {
          (_b = dialogElement.value) == null ? void 0 : _b.show();
        }
        if (!props.disableFocusTrap) {
          focusTrap.add(dialogElement);
        }
        if (tealium) {
          tealium.link({ wt_link_id: `content.${tealiumName.value}.${getTealiumRel()}.open` });
        }
      }, 1);
    }
    function closeNative() {
      focusTrap.remove();
      if (timeout.value) {
        clearTimeout(timeout.value);
      }
      emits("onCloseModal");
      if (tealium) {
        tealium.link({ wt_link_id: `content.${tealiumName.value}.${getTealiumRel()}.close` });
      }
      timeout.value = setTimeout(() => {
        isDialogOpen.value = false;
      }, 126);
    }
    function handleBackdropClick() {
      if (props.closeOnBackdrop) {
        closeDialog();
      }
    }
    onBeforeUnmount(() => {
      focusTrap.remove();
    });
    expose({ openDialog, closeDialog });
    return { __sfc: true, props, uid, emits, dialogElement, isDialogOpen, timeout, tealium, tealiumName, closeDialog, handleKeyEvent, getTealiumRel, focusTrap, openDialog, closeNative, handleBackdropClick, Heading, LinkButton };
  }
});
export {
  _sfc_main as default
};
